<template>
  <main class="h5-main">
    <Banner />
		<LmAesIntro />
		<LmAesRag />
		<LmAesFalcon />
		<LmAesActon />
		<LmAesDemoCases />
  </main>
</template>

<script>
	import Wait from './Wait'
	import Banner from './LmAesBanner'
  import LmAesIntro from './LmAesIntro'
	import LmAesRag from './LmAesRag'
	import LmAesFalcon from './LmAesFalcon'
	import LmAesActon from './LmAesActon'
	import LmAesDemoCases from './LmAesDemoCases'

export default {
  components: {
    Wait,
    Banner,
		LmAesIntro,
		LmAesRag,
		LmAesFalcon,
		LmAesActon,
		LmAesDemoCases
  },
  methods: {
    showWaitDialog() {
      this.$refs.waitDialog.showDialog();
    },
    goAI() {
      this.showWaitDialog();
      // window.location.href = "https://ai.mopaas.com/#/";
    }
  }
};
</script>

<style>
.h5-main {
  padding-top: 8vw;
  padding-bottom: 10.666666666666666vw;
  overflow: hidden;
}
.h5-main .home-container {
  padding: 5.2vw 3vw;
}
.h5-main .home-container:nth-of-type(odd) {
  background: #e7f1ff;
}
.h5-main .home-container:nth-of-type(even) {
  background: #f1f7ff;
}
.h5-main .home-title {
  padding-bottom: 4.533333333333333vw;
  font-size: 3.7333333333333334vw;
}

.h5-main .home-goAI {
  padding: 11.066666666666666vw 0 9.2vw;
  font-size: 3.2vw;
  text-align: center;
  background: url("../../assets/images/rengongbg.png");
}
.h5-main .home-goAI__text {
  font-size: 1.1666667em;
  color: #fff;
  vertical-align: middle;
}
.h5-main .home-goAI__btn {
  display: inline-block;
  padding: 1.6vw 4.133333333333334vw;
  border-radius: 0.26666666666666666vw;
  margin-left: 7.2vw;
  color: rgba(36, 53, 73, 1);
  vertical-align: middle;
  background: rgba(0, 235, 246, 1);
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/page/h5/portalLMAES.vue